import React, {useCallback, useEffect, useMemo, useState} from "react";
import { useForm } from "react-hook-form";
import OWASP from "../../../util/owasp";
import WaveButton from "../WaveButton.jsx";
import CONFIGURACIONES from "../../../util/constants";
import { Functions } from "../../../helpers/Functions.jsx";
import { Http } from "../../../helpers/Http.jsx";

const EndeudamientosModal = ({ show, onClose, onSave, showCreate, title, categoriasEvaluacion, initDataEndeudamiento, solicitudId }) => {
    const { handleSubmit: handleEndeudamientoSubmit, register: registerEndeudamiento, reset: resetEndeudamiento, getValues: getValuesEndeudamiento,
            setValue: setEndeudamientoValue, formState: { errors: errorsEndeudamiento } } = useForm({mode: "onChange"});

    const [detallesEndeudamientoExterno, setDetallesEndeudamientoExterno] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [detallesEndeudamientoInterno, setDetallesEndeudamientoInterno] = useState(CONFIGURACIONES.INIT.ARRAY);
   
    const [isEndeudamientoInterno, setIsEndeudamientoInterno] = useState(CONFIGURACIONES.INIT.NULL);

    const selectCategorias = useMemo(() => {
        return categoriasEvaluacion.filter(categoria => categoria.aplicado_a == CONFIGURACIONES.INIT.LIST_CATEGORIAS.ENDEUDAMIENTO_EXTERNO);
    }, [categoriasEvaluacion]);

    const selectCategoriasCalificacion = useMemo(() => {
        return categoriasEvaluacion.filter(categoria => categoria.aplicado_a == CONFIGURACIONES.INIT.LIST_CATEGORIAS.CLASIFICACION_DEUDOR);
    }, [categoriasEvaluacion]);

    const fnAgregarEndExterno = () => {
        let idGenerado = Functions().generarNumeroUnico(detallesEndeudamientoExterno);
        setDetallesEndeudamientoExterno([...detallesEndeudamientoExterno, {'id': idGenerado}]);
    };


    const fnObtenerEndeudamientoInterno = useCallback(() => {
        if (!showCreate || solicitudId == CONFIGURACIONES.INIT.NULL) { return; }
        Http().get(`${CONFIGURACIONES.ENDPOINTS.SOLICITUDES}/endeudamiento-interno/${solicitudId}`).then((rpta) => {
            if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                setDetallesEndeudamientoInterno(rpta.data.endeudamientoInterno);
            }
        });
    }, [showCreate, solicitudId, setDetallesEndeudamientoInterno, isEndeudamientoInterno]);

    useEffect(() => {
        resetEndeudamiento();
        console.log('isEndeudamientoInterno', isEndeudamientoInterno);
        
        if (initDataEndeudamiento !== CONFIGURACIONES.INIT.NULL) {
            console.log('entró?');
            
            const endeudamientos = initDataEndeudamiento.endeudamientos;
            const nuevoEndExterno = endeudamientos.filter(endeudamiento => endeudamiento.tipoEndeudamiento === CONFIGURACIONES.INIT.LIST_TIPO_ENDEUDAMIENTO.EXTERNO);
            const nuevoEndInterno = endeudamientos.filter(endeudamiento => endeudamiento.tipoEndeudamiento === CONFIGURACIONES.INIT.LIST_TIPO_ENDEUDAMIENTO.INTERNO);
            const tieneEndeudamientoInterno = nuevoEndInterno.length > 0;
            
            setIsEndeudamientoInterno(CONFIGURACIONES.INIT.NULL);
            setDetallesEndeudamientoExterno(nuevoEndExterno);
            setDetallesEndeudamientoInterno(nuevoEndInterno);
            setIsEndeudamientoInterno(tieneEndeudamientoInterno ? CONFIGURACIONES.INIT.STATUS_TRUE : CONFIGURACIONES.INIT.STATUS_FALSE);
            nuevoEndExterno.forEach(item => {
                setEndeudamientoValue(`entidad_${item.id}`, item.entidad);
                setEndeudamientoValue(`monto_${item.id}`, item.montoDesembolso);
                let avancePago = item.avancePago.split('/');
                setEndeudamientoValue(`avancePagoPagadas_${item.id}`, avancePago[0]);
                setEndeudamientoValue(`avancePagoTotal_${item.id}`, avancePago[1]);
                setEndeudamientoValue(`capitalPendiente_${item.id}`, item.capitalPendiente);
                setEndeudamientoValue(`categoria_${item.id}`, item.categoria);
                setEndeudamientoValue(`calificacion_${item.id}`, item.calificacion);
            });

            if (!tieneEndeudamientoInterno) { fnObtenerEndeudamientoInterno(); }
        }
    
    }, [initDataEndeudamiento, setEndeudamientoValue]);

    const fnPrevSave = (form) => {
        let endeudamientoExterno = [];
        let endeudamientoInterno = [];
       
        detallesEndeudamientoExterno.forEach(item => {
            endeudamientoExterno.push({
                'tipoEndeudamiento': 'EXTERNO',
                'entidad': getValuesEndeudamiento(`entidad_${item.id}`),
                'montoDesembolso': getValuesEndeudamiento(`monto_${item.id}`),
                'avancePago': `${getValuesEndeudamiento(`avancePagoPagadas_${item.id}`)}/${getValuesEndeudamiento(`avancePagoTotal_${item.id}`)}`,
                'capitalPendiente': getValuesEndeudamiento(`capitalPendiente_${item.id}`),
                'categoria': getValuesEndeudamiento(`categoria_${item.id}`),
                'calificacion': getValuesEndeudamiento(`calificacion_${item.id}`),
            })
        });

        detallesEndeudamientoInterno.forEach(item => {
            endeudamientoInterno.push({
                'tipoEndeudamiento': 'INTERNO',
                'capitalPendiente': item.capitalPendiente,
                'id': item.id,
            })
        });

        let data = {
            'interno': endeudamientoInterno,
            'externo': endeudamientoExterno
        };

        onSave(data);
    };

    return (
        <div
            className={`modal fade ${show ? "show d-block" : ""}`}
            tabIndex="-1"
            role="dialog"
            style={{ background: "rgba(0,0,0,0.5)" }}
        >
            <div className="modal-dialog modal-xxl modal-dialog-centered modal-fullscreen-sm-down" role="document">
                <form className="modal-content" action="" onSubmit={handleEndeudamientoSubmit(fnPrevSave)} autoComplete="off">
                    <div className="modal-header">
                        <h5 className="modal-title"> {title}</h5>
                        <button type="button" className="close" onClick={onClose}>
                            <span>&times;</span>
                        </button>
                    </div>

                    <div className="modal-body">
                        <div className="row">
                            <div className="col-sm-12">
                                <h6 className="text-muted mb-2 d-inline-block mr-2">Endeudamiento Interno</h6>
                                <WaveButton type="button" className="btn btn-sm btn-outline-success mb-1" content="Sincronizar Nuevamente" 
                                    place="right" dataTooltipId="add-endeudamiento-interno-tooltip" onClick={fnObtenerEndeudamientoInterno}>
                                    <i className="mdi mdi-refresh"></i>
                                </WaveButton>

                                <div style={{ maxHeight: '250px', overflowY: 'auto', marginBottom: '1rem' }} className="border rounded table-responsive">
                                    <table className="table table-sm w-100 mb-0" style={{ tableLayout: 'fixed' }}>
                                        <thead className="bg-light">
                                        <tr>
                                            <th className="p-2 text-center">Fecha</th>
                                            <th className="p-2 text-center">N° Solicitud</th>
                                            <th className="p-2 text-center">Monto</th>
                                            <th className="p-2 text-center">Avance de Pago</th>
                                            <th className="p-2 text-center">Capital Pendiente</th>
                                            <th className="p-2 text-center">Días de Atraso</th>
                                            <th className="p-2 text-center">Relación</th>
                                            <th className="p-2 text-center">Asesor</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            {detallesEndeudamientoInterno.length > 0? (
                                                detallesEndeudamientoInterno.map((item) => (
                                                    <tr key={item.id}>                            
                                                        <td className="p-2 text-center">{item.fecha}</td>
                                                        <td className="p-2 text-center">{item.numeroSolicitud}</td>
                                                        <td className="p-2 text-center">{item.montoDesembolso}</td>
                                                        <td className="p-2 text-center">{item.avancePago}</td>
                                                        <td className="p-2 text-center">{item.capitalPendiente}</td>
                                                        <td className="p-2 text-center">{item.diasAtraso}</td>
                                                        <td className="p-2 text-center">{item.relacion}</td>
                                                        <td className="p-2 text-center">{item.asesor}</td>
                                                    </tr>
                                                ))
                                            ): (
                                                    <tr>
                                                        <td colSpan="8" className="text-center text-muted">
                                                            <span className="text-danger">No se encontraron resultados</span>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div className="row mt-5">
                            <div className="col-sm-12">
                                <h6 className="text-muted mb-2 d-inline-block mr-2">Endeudamiento Externo</h6> 
                                <WaveButton type="button" className="btn btn-sm btn-outline-info mb-1" content="Agregar Item" 
                                    place="right" dataTooltipId="add-endeudamiento-tooltip" onClick={fnAgregarEndExterno}>
                                    <i className="mdi mdi-plus"></i>
                                </WaveButton>
                                <div style={{ maxHeight: '250px', overflowY: 'auto' }} className="border rounded table-responsive">
                                    <table className="table table-sm w-100 mb-0">
                                        <thead className="bg-light">
                                        <tr>
                                            <th style={{ width: '20%' }} className="p-2 text-center">Entidad</th>
                                            <th style={{ width: '10.5%' }} className="p-2 text-center">Monto</th>
                                            <th style={{ width: '17.5%' }} className="p-2 text-center">Avance de Pago</th>
                                            <th style={{ width: '10.5%' }} className="p-2 text-center">Capital Pendiente</th>
                                            <th style={{ width: '15.5%' }} className="p-2 text-center">Categoría</th>
                                            <th style={{ width: '17.5%' }} className="p-2 text-center">Calificación</th>
                                            <th style={{ width: '5.5%' }}></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            {detallesEndeudamientoExterno.length > 0? (
                                                detallesEndeudamientoExterno.map((item) => (
                                                    <tr key={item.id}>                            
                                                        <td style={{ width: '20%' }} className="p-2 text-center">
                                                            <input type="text" className="form-control form-control-sm text-uppercase" name={`entidad_${item.id}`} id={`entidad_${item.id}`} {...registerEndeudamiento(`entidad_${item.id}`, { 
                                                                    required: OWASP.REQUIRED,
                                                                    pattern: {
                                                                        value: OWASP.VALIDATIONS.GENERAL,
                                                                        message: OWASP.MESSAGES.DEFAULT
                                                                    },
                                                            })}/>   
                                                            <small className="invalid-feedback"> { errorsEndeudamiento[`entidad_${item.id}`]?.message}</small>
                                                        </td>
                                                        <td style={{ width: '10.5%' }} className="p-2 text-center">
                                                            <input type="text" className="form-control form-control-sm" name={`monto_${item.id}`} id={`monto_${item.id}`} {...registerEndeudamiento(`monto_${item.id}`, {
                                                                    required: OWASP.REQUIRED,
                                                                    pattern: {
                                                                        value: OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE,
                                                                        message: OWASP.MESSAGES.DEFAULT
                                                                    },
                                                            })}/>
                                                            <small className="invalid-feedback"> { errorsEndeudamiento[`monto_${item.id}`]?.message}</small>
                                                        </td>
                                                        <td style={{ width: '17.5%' }} className="p-2 text-center">
                                                            <div className="d-flex align-items-center">
                                                                <input type="text" className="form-control form-control-sm w-100 mr-1" name={`avancePagoPagadas_${item.id}`} id={`avancePagoPagadas_${item.id}`} 
                                                                    {...registerEndeudamiento(`avancePagoPagadas_${item.id}`, {
                                                                        required: OWASP.REQUIRED,
                                                                        pattern: {
                                                                            value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                                            message: OWASP.MESSAGES.DEFAULT
                                                                        },
                                                                })}/>
                                                                <span>/</span>
                                                                <input type="text" className="form-control form-control-sm w-100 ml-1" name={`avancePagoTotal_${item.id}`} id={`avancePagoTotal_${item.id}`} 
                                                                    {...registerEndeudamiento(`avancePagoTotal_${item.id}`, {
                                                                        required: OWASP.REQUIRED,
                                                                        pattern: {
                                                                            value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                                            message: OWASP.MESSAGES.DEFAULT
                                                                        },
                                                                })}/>
                                                            </div>
                                                            <small className="invalid-feedback"> { errorsEndeudamiento[`avancePagoPagadas_${item.id}`]?.message || errorsEndeudamiento[`avancePagoTotal_${item.id}`]?.message}</small>
                                                        </td>

                                                        <td style={{ width: '10.5%' }} className="p-2 text-center">
                                                            <input type="text" className="form-control form-control-sm" name={`capitalPendiente_${item.id}`} id={`capitalPendiente_${item.id}`} 
                                                                {...registerEndeudamiento(`capitalPendiente_${item.id}`, {
                                                                    required: OWASP.REQUIRED,
                                                                    pattern: {
                                                                        value: OWASP.VALIDATIONS.ONLY_DECIMALS_NOT_ZERO_NEGATIVE,
                                                                        message: OWASP.MESSAGES.DEFAULT
                                                                    },
                                                            })}/>
                                                            <small className="invalid-feedback"> { errorsEndeudamiento[`capitalPendiente_${item.id}`]?.message}</small>
                                                        </td>

                                                        <td style={{ width: '15.5%' }} className="p-2 text-center">
                                                            <select
                                                                {...registerEndeudamiento(`categoria_${item.id}`, {
                                                                    required: OWASP.REQUIRED,
                                                                    pattern: {
                                                                        value: OWASP.VALIDATIONS.GENERAL,
                                                                        message: OWASP.MESSAGES.DEFAULT
                                                                    },
                                                                })} className="form-control form-control-sm" name={`categoria_${item.id}`} id={`categoria_${item.id}`} 
                                                                defaultValue={""}
                                                            >
                                                                <option value="" disabled>Seleccione</option>
                                                                {
                                                                    selectCategorias.map((el, index) => (
                                                                        <option key={index} value={el.nombre}>{el.nombre}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                            <small className="invalid-feedback"> { errorsEndeudamiento[`categoria_${item.id}`]?.message}</small>
                                                        </td>

                                                        <td style={{ width: '17.5%' }} className="p-2 text-center">
                                                            <select
                                                                {...registerEndeudamiento(`calificacion_${item.id}`, {
                                                                    required: OWASP.REQUIRED,
                                                                    pattern: {
                                                                        value: OWASP.VALIDATIONS.GENERAL,
                                                                        message: OWASP.MESSAGES.DEFAULT
                                                                    },
                                                                })} className="form-control form-control-sm" name={`calificacion_${item.id}`} id={`calificacion_${item.id}`} 
                                                                defaultValue={""}
                                                            >
                                                                <option value="" disabled>Seleccione</option>
                                                                {
                                                                    selectCategoriasCalificacion.map((el, index) => (
                                                                        <option key={index} value={el.nombre}>{el.nombre}</option>
                                                                    ))
                                                                }
                                                            </select>
                                                            <small className="invalid-feedback"> { errorsEndeudamiento[`calificacion_${item.id}`]?.message}</small>
                                                        </td>

                                                        <td style={{ width: '5.5%' }} className="p-2 text-center">
                                                            <WaveButton type="button" className="btn btn-sm btn-outline-danger" onClick={() => {
                                                                setDetallesEndeudamientoExterno(detallesEndeudamientoExterno.filter((detalle) => detalle.id !== item.id));
                                                            }}>
                                                                <i className="mdi mdi-delete"></i>
                                                            </WaveButton>
                                                        </td>
                                                    </tr>
                                                ))
                                            ): (
                                                    <tr>
                                                        <td colSpan="6" className="text-center text-muted">
                                                            <span className="text-danger">No se encontraron resultados</span>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>


                        </div>
                    </div>

                    <div className="modal-footer">
                        <WaveButton type="button" className="btn btn-sm btn-outline-danger" onClick={onClose}>
                            <i className="mdi mdi-arrow-left"></i> Cerrar
                        </WaveButton>
                        {showCreate && <WaveButton type="submit" className="btn btn-sm btn-success waves-effect">
                            <i className="mdi mdi-content-save-settings"></i> Guardar
                        </WaveButton>}
                    </div>
                </form>
            </div>
        </div>
    );
};
export default EndeudamientosModal;
